/**
 * "Come nasce" stage. The active progress bar's CSS animation is the timer: its animationend moves
 * to the next step, so hover/focus pausing is only animation-play-state. Any manual navigation
 * stops the autoplay for good; with reduced motion it never starts.
 */
class PoianaSteps extends HTMLElement {
  connectedCallback() {
    this.backgrounds = [...this.querySelectorAll('[data-step-bg]')];
    this.texts = [...this.querySelectorAll('[data-step-text]')];
    this.bars = [...this.querySelectorAll('.steps__bar')];
    this.thumbs = [...this.querySelectorAll('.steps__thumb')];
    this.index = 0;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.removeAttribute('data-autoplay');

    this.addEventListener('click', (event) => {
      const go = event.target.closest('[data-step-go]');
      const move = event.target.closest('[data-step-move]');
      if (!go && !move) return;
      this.removeAttribute('data-autoplay');
      const count = this.texts.length;
      this.show(go ? Number(go.dataset.stepGo) : (this.index + Number(move.dataset.stepMove) + count) % count);
    });

    this.addEventListener('animationend', (event) => {
      if (!event.target.classList.contains('steps__fill') || !this.hasAttribute('data-autoplay')) return;
      this.show((this.index + 1) % this.texts.length);
    });

    const pause = () => this.setAttribute('data-paused', '');
    const resume = () => this.removeAttribute('data-paused');
    this.addEventListener('mouseenter', pause);
    this.addEventListener('mouseleave', resume);
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) resume();
    });
  }

  markCurrent(node, on) {
    if (on) node.setAttribute('aria-current', 'true');
    else node.removeAttribute('aria-current');
  }

  show(index) {
    this.index = index;
    this.backgrounds.forEach((node, i) => node.classList.toggle('is-active', i === index));
    this.texts.forEach((node, i) => {
      node.hidden = i !== index;
    });
    this.bars.forEach((node, i) => {
      node.classList.toggle('is-active', i === index);
      node.classList.toggle('is-done', i < index);
      this.markCurrent(node, i === index);
    });
    this.thumbs.forEach((node, i) => {
      node.classList.toggle('is-active', i === index);
      this.markCurrent(node, i === index);
    });
  }
}

if (!customElements.get('poiana-steps')) customElements.define('poiana-steps', PoianaSteps);
